import {
  BLACKLIST_REQUEST,
  BLACKLIST_SUCCESS,
  BLACKLIST_FAILED,
  REMOVE_FROM_BLACKLIST_REQUEST,
  REMOVE_FROM_BLACKLIST_ERROR,
  REMOVE_FROM_BLACKLIST_SUCCESS
} from './blackListConstants';

import { BASE_URL, UUID } from '../../../middleware/api';
import {
  SET_BLACK_LIST,
  REMOVE_FROM_BLACKLIST
} from '../../../services/ApiEndpointsConstants';

export const setDomainToBlackList = (id) => {
  return async (dispatch) => {
    if (!id) {
      return;
    }

    const token = localStorage.getItem(UUID) || null;

    dispatch({ type: BLACKLIST_REQUEST });

    let blackListData = null;

    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    };

    try {
      const response = await fetch(
        `${BASE_URL}${SET_BLACK_LIST}${id}`,
        requestOptions
      );
      const result = await response.json();
      blackListData = result;
    } catch (error) {
      console.error('Error fetching black list data from the server', error);
    }

    if (!blackListData) {
      return dispatch({ type: BLACKLIST_FAILED });
    }

    return dispatch({
      type: BLACKLIST_SUCCESS,
      blackListData
    });
  };
};

export const removeFromBlackList = (id) => {
  return async (dispatch) => {
    if (!id) {
      return;
    }

    const token = localStorage.getItem(UUID) || null;

    dispatch({ type: REMOVE_FROM_BLACKLIST_REQUEST });

    let blackListData = null;

    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    };

    try {
      const response = await fetch(
        `${BASE_URL}${REMOVE_FROM_BLACKLIST.replace('{id}', id)}`,
        requestOptions
      );
      const result = await response.json();
      blackListData = result;
    } catch (error) {
      console.error('Error fetching black list data from the server', error);
    }

    if (!blackListData) {
      return dispatch({ type: REMOVE_FROM_BLACKLIST_ERROR });
    }

    return dispatch({
      type: REMOVE_FROM_BLACKLIST_SUCCESS
    });
  };
};
